import {toast} from 'react-toastify';

let initialState = {
	loader: false,
	infos: [],
	one: [],
	create: [],
	update: []
};

const getTremplinsInfos = (state = initialState, action) => {
	switch (action.type) {
		case 'GET_TREMPLINS_RETURN':
			return Object.assign({}, state, {infos: action.payload});

		case 'GET_TREMPLIN_SAGAS':
			return Object.assign({}, state, {loader: true});

		case 'GET_TREMPLIN_RETURN':
			return Object.assign({}, state, {
				one: action.payload,
				loader: false
			});

		case 'POST_TREMPLIN_RETURN':
			const arrayCat = [action.payload.data];
			let newStateAdd;
			if (action.payload.status === 201) {
				newStateAdd = {...state.infos, data: state.infos.data.concat(arrayCat)};
				const notifySuccess = () =>
					toast.success('Tremplin ajouté !', {
						position: 'top-right',
						autoClose: 2000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifySuccess();
			} else {
				newStateAdd = state.infos;
				if (action.payload.status === 400) {
					const notifyError = () =>
						toast.error('Email déjà enregistré !', {
							position: 'top-right',
							autoClose: 3000,
							hideProgressBar: false,
							closeOnClick: true,
							pauseOnHover: true,
							draggable: true,
							progress: undefined
						});
					notifyError();
				}
			}
			return Object.assign({}, state, {
				create: action.payload,
				infos: newStateAdd
			});

		case 'PUT_TREMPLIN_RETURN':
			let array = [];
			let newStateUpdate;
			if (action.payload.status === 202) {
				array = state.infos.data.map((item) => {
					return item.uuid === action.payload.data.uuid ? action.payload.data : item;
				});
				newStateUpdate = {...state.infos, data: array};
				const notifySuccess = () =>
					toast.success('Tremplin mis à jour !', {
						position: 'top-right',
						autoClose: 2000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifySuccess();
			} else {
				const notifyError = () =>
					toast.error('Erreur ! merci de le signaler...', {
						position: 'top-right',
						autoClose: 3000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifyError();
			}
			return Object.assign({}, state, {
				update: action.payload,
				infos: newStateUpdate
			});

		case 'CLOTURE_TREMPLIN_RETURN':
			let arrayCloture = [];
			let newStateUpdate2;
			if (action.payload.status === 202) {
				arrayCloture = state.infos.data.map((item) => {
					return item.uuid === action.payload.data.uuid ? action.payload.data : item;
				});
				newStateUpdate2 = {...state.infos, data: arrayCloture};
				const notifySuccess = () =>
					toast.success('Tremplin clôturé !', {
						position: 'top-right',
						autoClose: 2000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifySuccess();
			} else {
				const notifyError = () =>
					toast.error('Erreur ! merci de le signaler...', {
						position: 'top-right',
						autoClose: 3000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifyError();
			}
			return Object.assign({}, state, {
				update: action.payload,
				infos: newStateUpdate2
			});

		case 'DEL_TREMPLIN_SAGAS':
			const tremplin = state.infos.data;
			const indexTremplin = tremplin.findIndex((index) => index.uuid === action.payload);
			const newStateDelete = {...state.infos, data: tremplin.filter((item, i) => i !== indexTremplin)};

			return Object.assign({}, state, {infos: newStateDelete});

		case 'DEL_TREMPLIN_RETURN':
			if (action.payload.status === 202) {
				const notifySuccess = () =>
					toast.success('Tremplin supprimé !', {
						position: 'top-right',
						autoClose: 2000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifySuccess();
			} else {
				const notifyError = () =>
					toast.error('Erreur ! merci de le signaler...', {
						position: 'top-right',
						autoClose: 3000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifyError();
			}
			return Object.assign({}, state, {delete: action.payload});

		default:
			return state;
	}
};

export default getTremplinsInfos;
